<template>
  <v-row no-gutters dense class="mt-1 mb-2">
    <v-col cols="12" sm="1">
      <v-text-field
          dense v-model="form.codigo" label="codigo" outlined persistent-placeholder
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="2">
      <v-text-field
          dense v-model="form.ProductoServicio" label="ProductoServicio" outlined persistent-placeholder
          hide-details
          :rules="required"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="1">
      <v-text-field
          dense v-model.number="form.cantidad" type="number" label="Cantidad" outlined persistent-placeholder
          hide-details @input="calc"
          :rules="required"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="1">
      <v-text-field
          dense v-model="form.unidadMedida" label="Unidad Medida"
          outlined persistent-placeholder hide-details
          :rules="required"
      >
      </v-text-field>
    </v-col>
    <v-col cols="12" sm="2">
      <v-text-field
          dense v-model.number="form.precioUnitario" type="number" label="Precio Unitario" outlined
          persistent-placeholder hide-details @input="calc"
          :rules="required"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="2">
      <v-text-field readonly background-color="grey lighten--3"
                    dense v-model.number="form.subtotal" type="number" label="Subtotal" outlined
                    persistent-placeholder hide-details
      ></v-text-field>
    </v-col>
    <v-col v-if="iva" cols="12" sm="1">
      <tipo-alicuota-combobox
          v-model.number="form.alicuotaIva"
          dense outlined persistent-hint hide-details
          @input="calc"
      ></tipo-alicuota-combobox>
    </v-col>
    <v-col v-if="iva" cols="12" sm="2">
      <v-text-field readonly dense v-model.number="form.subtotalConIva" type="number" label="Subtotal C/IVA" outlined
                    persistent-placeholder hide-details></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import TipoAlicuotaCombobox from "@/modules/afip/components/TipoAlicuotaCombobox/TipoAlicuotaCombobox";
import IvaMixin from "@/modules/afip/mixins/IvaMixin";
import {RequiredRule} from "@dracul/common-frontend";

export default {
  name: "FacturaFormDetalleProductoServicio",
  components: {TipoAlicuotaCombobox},
  props: {
    value: Object,
    iva: {type: Boolean}
  },
  mixins: [IvaMixin, RequiredRule],
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
  },
  methods: {
    calc() {
      this.form.subtotal = this.form.cantidad * this.form.precioUnitario
      this.form.alicuotaIvaPorcentaje = this.getPorcentajeAlicuota(this.form.alicuotaIva)
      this.form.precioUnitarioConIva = this.form.precioUnitario + Math.round(this.form.precioUnitario * this.form.alicuotaIvaPorcentaje / 100)
      this.form.subtotalConIva = this.form.cantidad * this.form.precioUnitarioConIva
    }
  }
}
</script>

<style scoped>

</style>
